module.exports = __webpack_public_path__ + "93ba1c3534cae4a7ba11cf8b4c93324f.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/retribution.mp4
// module id = 643
// module chunks = 0